var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_262_11013",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20",
          },
        },
        [_c("rect", { attrs: { width: "20", height: "20", fill: "#D9D9D9" } })]
      ),
      _vm._v(" "),
      _c("g", { attrs: { mask: "url(#mask0_262_11013)" } }, [
        _c("path", {
          attrs: {
            d: "M2 9.99042C2 8.88569 2.20833 7.85069 2.625 6.88542C3.04167 5.92014 3.61458 5.07292 4.34375 4.34375C5.07292 3.61458 5.92229 3.04167 6.89188 2.625C7.86146 2.20833 8.8975 2 10 2C11.7361 2 13.2708 2.48264 14.6042 3.44792C15.9375 4.41319 16.8958 5.65278 17.4792 7.16667C17.5625 7.38889 17.559 7.60764 17.4688 7.82292C17.3785 8.03819 17.2296 8.18368 17.0221 8.25938C16.8268 8.32257 16.6389 8.29861 16.4583 8.1875C16.2778 8.07639 16.1528 7.92361 16.0833 7.72917C15.7639 6.89583 15.2951 6.15625 14.6771 5.51042C14.059 4.86458 13.3333 4.36806 12.5 4.02083V4.5C12.5 4.9125 12.3531 5.26562 12.0594 5.55937C11.7656 5.85312 11.4125 6 11 6H9V7C9 7.28333 8.90417 7.52083 8.7125 7.7125C8.52083 7.90417 8.28333 8 8 8H7V10H7.25C7.4625 10 7.64062 10.0719 7.78438 10.2156C7.92813 10.3594 8 10.5375 8 10.75V12H7L3.64583 8.64583C3.60944 8.86806 3.57604 9.09028 3.54563 9.3125C3.51521 9.53472 3.5 9.76389 3.5 10C3.5 11.6944 4.0625 13.1597 5.1875 14.3958C6.3125 15.6319 7.70139 16.3264 9.35417 16.4792C9.54861 16.5069 9.70486 16.5938 9.82292 16.7396C9.94097 16.8854 10 17.059 10 17.2604C10 17.4618 9.92014 17.6354 9.76042 17.7812C9.60069 17.9271 9.415 17.9869 9.20333 17.9608C7.17889 17.7647 5.47222 16.9097 4.08333 15.3958C2.69444 13.8819 2 12.0801 2 9.99042ZM16.4208 16.9646L14.375 14.9375C14.0972 15.1181 13.8028 15.2569 13.4917 15.3542C13.1806 15.4514 12.85 15.5 12.5 15.5C11.5278 15.5 10.7014 15.1597 10.0208 14.4792C9.34028 13.7986 9 12.9722 9 12C9 11.0278 9.34028 10.2014 10.0208 9.52083C10.7014 8.84028 11.5278 8.5 12.5 8.5C13.4722 8.5 14.2986 8.83993 14.9792 9.51979C15.6597 10.1997 16 11.0252 16 11.9965C16 12.346 15.9514 12.6771 15.8542 12.9896C15.7569 13.3021 15.6181 13.5972 15.4375 13.875L17.4833 15.9208C17.6333 16.0708 17.7083 16.2431 17.7083 16.4375C17.7083 16.6319 17.6319 16.8056 17.4792 16.9583C17.3264 17.1111 17.1493 17.1875 16.9479 17.1875C16.7465 17.1875 16.5708 17.1132 16.4208 16.9646ZM12.4952 14C13.054 14 13.5278 13.8072 13.9167 13.4215C14.3056 13.0356 14.5 12.5634 14.5 12.0048C14.5 11.446 14.3072 10.9722 13.9215 10.5833C13.5356 10.1944 13.0634 10 12.5048 10C11.946 10 11.4722 10.1928 11.0833 10.5785C10.6944 10.9644 10.5 11.4366 10.5 11.9952C10.5 12.554 10.6928 13.0278 11.0785 13.4167C11.4644 13.8056 11.9366 14 12.4952 14Z",
            fill: "#1C1B1F",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }